module.exports = "<search-bar search-term=$ctrl.searchTerm on-search=$ctrl.onSearch($event) spellcheck=$ctrl.spellcheck></search-bar> <web-results on-load-more-results=$ctrl.onLoadMoreResults() results=$ctrl.webResults loading=$ctrl.webResults.loading search-term=$ctrl.searchTerm search-term-to-search=$ctrl.searchTermToSearch infinite-scroll-disabled=$ctrl.infiniteScrollDisabled></web-results> <feedback-modal is-open=$ctrl.feedbackModal.open on-cancel=$ctrl.closeModal() on-complete=$ctrl.modalActionComplete($event)></feedback-modal> ";


//////////////////
// WEBPACK FOOTER
// ./src/search-interface/search-interface.html
// module id = 66
// module chunks = 1